<template>
    <div class="pl-4 rounded bg-gray-50">
        <span class="text-2xl text-main-600">
            {{ $t('labels.customer') }}
        </span>
        <div class="pt-1 flex">
            <span class="w-1/2 font-bold">
                {{ dataCreateQuote.customerName }}
            </span>
            <div class="w-1/2 flex flex-col">
                <span>
                    {{ $t('labels.address') }}: {{ dataCreateQuote.cooperatorDetail?.locationName }}
                </span>
                <span>
                    {{ $t('labels.contact') }}: {{ dataCreateQuote.contactDetail?.fullName }} - {{ dataCreateQuote.contactDetail?.phone }} -
                    {{ dataCreateQuote.contactDetail?.email }}
                </span>
            </div>
        </div>
        <div class="flex pt-1">
            <div class="w-1/2 flex flex-col">
                <span class="text-2xl text-main-600">
                    {{ $t('labels.quoteInformation') }}
                </span>
                <span class="font-bold pt-1">
                    {{ $t('labels.workflow') }} : {{ getTextWorkFlow(dataCreateQuote.positions) }}
                </span>
                <span class="font-bold pt-1">
                    {{ $t('labels.row') }} : {{ generateName() }} - {{ $formatters.formatCurrency(dataCreateQuote.weightCommodity) }} kg
                </span>
                <span
                    v-if="dataCreateQuote.contCategory && dataCreateQuote.transportation === 'CONTAINER'"
                    class="font-bold pt-1">
                    {{ $t('labels.containerType') }} : {{ listLabelCont[dataCreateQuote.contCategory] || 'unknow' }}
                </span>
                <span
                    v-if="dataCreateQuote.transportation === 'NON_CONTAINER'"
                    class="font-bold pt-1">
                    {{ $t('labels.vehicleType') }} : {{ dataCreateQuote.vehicleCategoryName }}
                </span>
                <span class="font-bold pt-1">
                    {{ $t('labels.productivityByMount') }} :
                    {{ $formatters.formatCurrency(dataCreateQuote.productivity) }}
                    {{ dataCreateQuote.transportation ? (dataCreateQuote.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                </span>
                <div
                    v-if="type !== 'create'"
                    class="font-bold pt-1 flex space-x-1 items-center">
                    <span>
                        {{ $t('labels.status') }}:
                    </span>
                    <div v-if="dataCreateQuote.status === 2 || type === 'view' || !cListStatusQuote.length">
                        <status-component
                            size="large"
                            module="quote"
                            :status="dataCreateQuote.status" />
                    </div>
                    <div
                        v-else
                        class="flex items-center gap-2">
                        <status-component
                            size="large"
                            module="quote"
                            :status="dataCreateQuote.status || 0" />
                        <hts-dropdown
                            trigger="click"
                            class="w-52"
                            :options="cListStatusQuote"
                            :placement="'bottom'"
                            :offset="[0, 15]"
                            label-key="label"
                            @click="handelEditStatus">
                            <template #default="{ item }">
                                <div class="w-52">
                                    <status-component
                                        size="large"
                                        module="quote"
                                        :status="item.value" />
                                </div>
                            </template>
                            <template #reference>
                                <div class="flex items-center cursor-pointer">
                                    <hi-pencil-square-icon class="h-5 w-5 text-blue-600 hover:text-blue-500" />
                                </div>
                            </template>
                        </hts-dropdown>
                    </div>
                </div>
            </div>
            <div class="flex w-1/2 flex-col">
                <span class="text-2xl text-main-600">
                    {{ $t('labels.node') }}
                </span>
                <ul
                    v-if="dataCreateQuote.positions && dataCreateQuote.positions.length"
                    class="steps steps-vertical w-full">
                    <li
                        v-for="(item, index) in dataCreateQuote.positions"
                        :key="index"
                        data-content=" "
                        class="step w-full">
                        <div class="w-full text-left">
                            <p class="font-bold">
                                {{ item.fullNameNode }}
                            </p>
                            <p
                                v-if="item.locationName"
                                class="pt-1">
                                {{ item.locationName }}
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    <!--    <hts-modal -->
    <!--      :show="openPopupEditStatus" -->
    <!--      :title="$t('labels.editStatusQuote')" -->
    <!--      type="confirm" -->
    <!--      :content="$t('labels.confirmEditStatusQuote')" -->

    <!--      @hide="openPopupEditStatus = false" -->
    <!--      @confirm="handelEditStatus" -->
    <!--    /> -->
    </div>
</template>

<script lang="ts" setup>
import { addQuote } from './ignore/imports/form'
import StatusComponent from '@/pages/trucker-[id]/statistics/-components/status.vue'
import listStatus from '~/fucntion/quote/status'
const { $formatters } = useNuxtApp()

const props = defineProps({
  dataCreateQuote: {
    type: Object as PropType<addQuote>,
    required: true
  },
  type: {
    type: String,
    default: 'view'
  }
})
const { dataCreateQuote } = toRefs(props)

const emits = defineEmits(['loaded'])
const generateName = () => {
  const typeCommodity = []
  if (dataCreateQuote.value) {
    if (
      dataCreateQuote.value.typeCommodity === 'NORMAL' &&
      dataCreateQuote.value.goodType === 'SOLID' &&
      dataCreateQuote.value.typeDangerous === 'NOTDANGEROUS' &&
      dataCreateQuote.value.typeFragileGoods === 'NOTFRAGILE' &&
      dataCreateQuote.value.typeReefer === 'NOTREEFER'
    ) {
      typeCommodity.push($t('labels.ordinaryGoods'))
    } else {
      if (dataCreateQuote.value.goodType === 'LIQUID') {
        typeCommodity.push($t('labels.liquidGoods'))
      }
      if (dataCreateQuote.value.goodType === 'GAS') {
        typeCommodity.push($t('labels.gasGoods'))
      }
      if (dataCreateQuote.value.typeReefer === 'REEFER') {
        typeCommodity.push($t('labels.coolGoods'))
      }
      if (dataCreateQuote.value.typeDangerous === 'DANGEROUS') {
        typeCommodity.push($t('labels.hazardousGoods'))
      }
      if (dataCreateQuote.value.typeFragileGoods === 'FRAGILE') {
        typeCommodity.push($t('labels.fragileGoods'))
      }
      if (dataCreateQuote.value.typeCommodity === 'OVERWEIGHT') {
        typeCommodity.push($t('labels.superHeavyGoods'))
      }
    }
  }

  return typeCommodity.join(', ')
}

const getTextWorkFlow = (positions: Array<{ [key: string]: any }>, key: string = 'nodeTypeName') => {
  if (positions && Array.isArray(positions)) {
    const pluckData = $lodash.map(positions, key)

    return $lodash.join(pluckData, ' >> ')
  }
}
const dataCoppyQuote = ref<addQuote>()
onBeforeMount(() => {
  dataCoppyQuote.value = $lodash.cloneDeep(dataCreateQuote.value)
})

const cListStatusQuote = computed(() => {
  const result: Array<{ label: string; value: number }> = []
  listStatus().forEach((item: { label: string; value: number }) => {
    if (dataCoppyQuote.value && dataCoppyQuote.value.status === 0 && [1, 3, 0].includes(item.value)) {
      result.push(item)
    }
    if (dataCoppyQuote.value && dataCoppyQuote.value.status === 1 && [3, 1].includes(item.value)) {
      result.push(item)
    }
    if (dataCoppyQuote.value && dataCoppyQuote.value.status === 3 && [0, 3].includes(item.value)) {
      result.push(item)
    }
  })
  return $lodash.sortBy(result, [
    (item: { label: string; value: number }) => {
      if (dataCoppyQuote.value && item.value === dataCoppyQuote.value.status) {
        return true
      }
    }
  ])
})

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const openPopupEditStatus = ref(false)
const statusEdit = ref(0)

const handleOpenPopupEditStatus = (item: { label: string; value: number }) => {
  statusEdit.value = item.value
  openPopupEditStatus.value = true
}

const loadingEditStatus = ref(false)
const handelEditStatus = (item: { label: string; value: number }) => {
  dataCreateQuote.value.status = item.value
}
</script>
~/fucntion/quote/status
